import { defaultFill } from '../../utils/constants';
var muiMapPinFill16 = {
    paths: [
        {
            path: 'M6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 7.19976899,15.3366104 7.19976899,15.3366104 C6.54304227,16.2285996 5.46284513,16.2221383 4.80023101,15.3366104 C4.80023101,15.3366104 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,4 C4.8954305,4 4,4.8954305 4,6 C4,7.1045695 4.8954305,8 6,8 C7.1045695,8 8,7.1045695 8,6 C8,4.8954305 7.1045695,4 6,4 Z',
            fill: defaultFill,
        },
    ],
    title: 'Map Pin',
    width: 12,
    height: 16,
};
var muiMapPinFill24 = {
    paths: [
        {
            path: 'M8.99821075,0 C13.9677853,0 17.9964215,3.95092689 17.9964215,8.82464219 C17.9964215,13.6983575 10.2211141,23.3300968 10.2211141,23.3300968 C9.54754385,24.2135688 8.45489095,24.2109307 7.78467201,23.3425316 C7.78467201,23.3425316 0,13.6983575 0,8.82464219 C0,3.95092689 4.02863618,0 8.99821075,0 Z M9,5.88426462 C7.34314575,5.88426462 6,7.20150212 6,8.82639693 C6,10.4512917 7.34314575,11.7685292 9,11.7685292 C10.6568542,11.7685292 12,10.4512917 12,8.82639693 C12,7.20150212 10.6568542,5.88426462 9,5.88426462 Z',
            fill: defaultFill,
        },
    ],
    title: 'Map Pin',
    width: 18,
    height: 24,
};
var muiMapPinFill = {
    base: muiMapPinFill16,
    smIcon: muiMapPinFill16,
    lgIcon: muiMapPinFill24,
};
export { muiMapPinFill };
//# sourceMappingURL=mapPinFill.js.map